import solver from 'solver-utilities';

const menuClose = async function (event) {
	if (event) event.preventDefault();

	const navigation = document.getElementById('solver-navigation');
	if (!navigation) return;

	navigation.classList.remove('nav--active');
};

const menuOpen = function (event) {
	if (event) event.preventDefault();

	const navigation = document.getElementById('solver-navigation');
	if (!navigation) return;

	navigation.classList.add('nav--active');
};

const menuSelect = function (event) {
	const href = event.target.value;
	if (href) window.location.href = href;
};

export const navigation = function () {
	window.menuOpen = menuOpen;
	window.menuClose = menuClose;
	window.menuSelect = menuSelect;
};
